import { render, staticRenderFns } from "./NotificationResult-Reject.vue?vue&type=template&id=1796b295&scoped=true"
import script from "./NotificationResult-Reject.vue?vue&type=script&lang=js"
export * from "./NotificationResult-Reject.vue?vue&type=script&lang=js"
import style0 from "./NotificationResult-Reject.vue?vue&type=style&index=0&id=1796b295&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1796b295",
  null
  
)

export default component.exports